// extracted by mini-css-extract-plugin
export default {"quill_editor_container":"Editor_quill_editor_container__ilqBv"};